<div class="epds_mat_override">
  <form #f="ngForm" (ngSubmit)="onSearch(f.value)" role="search">
    <mat-card appearance="outlined">
      <mat-card-header fxLayout="row" fxLayoutAlign="center">
        <mat-card-title role="heading" aria-level="1">User Search</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        <div fxLayout="row wrap" fxLayoutAlign="center center" fxLayoutGap="8px grid">
          <mat-form-field fxFlex="50%" fxFlex.lt-md="100%" floatLabel="always" appearance="outline">
            <mat-label>Email</mat-label>
            <input matInput name="email" ngModel type="text" [(ngModel)]="stateService.search_email">
            <button mat-icon-button *ngIf="stateService.search_email" matSuffix aria-label="Clear"
              (click)="stateService.search_email=undefined">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field fxFlex="50%" fxFlex.lt-md="100%" floatLabel="always" appearance="outline">
            <mat-label>First Name</mat-label>
            <input matInput name="firstName" ngModel type="text" maxlength="32"
              [(ngModel)]="stateService.search_firstname">
            <button mat-icon-button *ngIf="stateService.search_firstname" matSuffix aria-label="Clear"
              (click)="stateService.search_firstname=undefined">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field fxFlex="50%" fxFlex.lt-md="100%" floatLabel="always" appearance="outline">
            <mat-label>Last Name</mat-label>
            <input matInput name="lastName" ngModel type="text" maxlength="32" [(ngModel)]="stateService.search_lastname">
            <button mat-icon-button *ngIf="stateService.search_lastname" matSuffix aria-label="Clear"
              (click)="stateService.search_lastname=undefined">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
          <mat-form-field fxFlex="50%" fxFlex.lt-md="100%" floatLabel="always" appearance="outline">
            <mat-label>Name of Agency/Firm</mat-label>
            <input matInput name="nameOfFirm" ngModel type="text" maxlength="32" [(ngModel)]="stateService.search_Agency">
            <button mat-icon-button *ngIf="stateService.search_Agency" matSuffix aria-label="Clear"
              (click)="stateService.search_Agency=undefined">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
      </mat-card-content>
      <mat-card-actions fxLayout="row" fxLayoutAlign="center" fxLayoutGap="16px">
        <div fxFlex="50">
          <button mat-raised-button type="button" color="accent" (click)="onExport()"
            [disabled]="!dataSource.data.length">Export</button>
          <div fxFlex=""></div>
          <button color="primary" mat-raised-button type="submit" [disabled]="disableSearch || searching" class="spinner-black">
            <div *appSpinner="searching"></div>
            Search
          </button>
        </div>
        <div fxFlex="50">
          <button color="accent" mat-raised-button type="reset" (click)="f.reset()">Reset</button>
        </div>
      </mat-card-actions>
    </mat-card>
  </form>

  <mat-card appearance="outlined">
    <mat-card-content fxLayout="column" class="no-bottom-pad">
      <div fxLayout>
        <div fxLayoutAlign="start" fxFlex="20">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput type="text" (keyup)="applyFilter($event)" #filterInput>
            <button mat-icon-button *ngIf="filterInput.value" matSuffix aria-label="Clear"
                    (click)="filterInput.value='';applyFilter($event); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>

        <div fxLayoutAlign="end" fxFlex="80">
          <mat-paginator appPaginationSave [lsKey]="'user_search_page_size'" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                         aria-label="Select page of users"></mat-paginator>
        </div>
      </div>
      <div class="scrollable-content">
        <table mat-table matSort [dataSource]="dataSource" class="search-table">
          <ng-container matColumnDef="email">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Email"> Email Address
            </th>
            <td mat-cell *matCellDef="let user">
              {{user.email}}
  <!--            <a [routerLink]="[userUrl]" [queryParams]="{user_Id: user.user_Id}">{{user.email}}</a>-->
            </td>
          </ng-container>
          <ng-container matColumnDef="firstName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by First Name"> First Name
            </th>
            <td mat-cell *matCellDef="let user"> {{user.firstName}} </td>
          </ng-container>
          <ng-container matColumnDef="lastName">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Last Name"> Last Name
            </th>
            <td mat-cell *matCellDef="let user"> {{user.lastName}} </td>
          </ng-container>
          <ng-container matColumnDef="agencyFirm">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Agency or Firm"> Agency /
              Firm </th>
            <td mat-cell *matCellDef="let user"> {{user.agency}} </td>
          </ng-container>
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef> Action </th>
            <td mat-cell *matCellDef="let row">
              <div fxLayout="row">
                <button class="button-cell" mat-raised-button color="primary" (click)="onEdit($event, row)">Edit</button>
                <button class="button-cell" mat-raised-button color="warn" (click)="onDelete($event, row)">Delete</button>
                <button mat-raised-button color="accent" (click)="onReset($event, row)">Reset</button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" (click)="onEditUser(row)" (keyup)="onKeypress($event, row)" tabindex="0"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">No data or nothing that matches the filter "{{filterInput.value}}"</td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
